<template>
  <div class="mt-0" style="min-height: calc(100vh - 30px)" tag="section">
    <b-row class="justify-content-center no-gutters">
      <b-col lg="12" class="d-flex align-items-center">
        <b-card no-body class="w-100">

          <b-row class="no-gutters reset">
            <b-col cols="1" md="4" lg="4"></b-col>

            <b-col cols="10" md="4" lg="4" class="d-md-flex align-items-center justify-content-center">
              <b-card class="max-height-img layered box" no-body img-alt="Image" img-top align="center"
                header-text-variant="white" header-tag="header" header-bg-variant="azul">
                <template #header>
                  <h2 class="mb-0" style="color:white; font-weight: 550; font-size: 30px;">ACIQUI</h2>
                </template>

                <b-card-body>
                  <h2 class="font-weight-bold mt-2 mb-4">Restablecer contraseña</h2>

                  <b-form @submit.stop.prevent="cambiarContrasena" align="left" style="z-index: 1;">
                    <p class="mb-3 ml-2 camposObligatorios">*Campos obligatorios</p>
                    <b-col cols="12" sm="12">
                      <div class="row">
                        <b-col class="align-items-center" cols="12" sm="12">
                          <label for="password">Nueva contraseña* :</label>
                          <b-form-input id="password" type="password" v-model="usuario.contrasena" required
                            name="password" placeholder="Introduce una contraseña" :state="passwordState"
                            pattern=".{6,}" description="Por favor introduce una contraseña"
                            title="La contraseña debe tener al menos 6 caracteres"
                            @blur="passwordHasBlurred = true"></b-form-input>
                          <b-form-invalid-feedback id="password-feedback-required">Ingrese la
                            contraseña</b-form-invalid-feedback>
                          <b-form-invalid-feedback :state="passwordState">
                            Tu contraseña debe estar compuesta <br>por al menos 3 palabras separadas por<br> espacios de
                            al menos 12
                            caracteres en total<br>
                          </b-form-invalid-feedback>
                        </b-col>
                      </div>
                      <div class="row">
                        <b-col class="align-items-center" cols="12" sm="12">
                          <label for=“confirmPassword”>Confirmación de nueva contraseña* :</label>
                          <b-form-input id="confirmPassword" v-model="usuario.confirmar" type="password" required
                            placeholder="Confirma tu contraseña" :state="confirmPasswordState" pattern=".{6,}"
                            @blur="passwordHasBlurred = true"></b-form-input>
                          <b-form-invalid-feedback :state="confirmPasswordState">
                            Contraseña y confirmación son diferentes
                          </b-form-invalid-feedback>
                        </b-col>
                      </div>
                    </b-col>
                    <b-btn variant="info" class="mt-3" style="color:white; margin: 10px;" type="submit"
                      :disabled="!(passwordState && confirmPasswordState)">Cambiar contraseña</b-btn>
                    <b-btn color="primary" style="color:white;" class="mt-2" @click="CancelarCambioContrasena()">Cancelar</b-btn>
                  </b-form>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script src="js/main.js"></script>
<script>
import UsersDataService from "../../services/UsersDataService";
import Crypto from "../../services/Crypto";
import AccionesDataService from "../../services/AccionesDataService";


import {App} from "../../App";

export default {
  name: 'restablecer-contrasena',
  data(){
    return {
      usuario:{
        id: 0,
        nombre: "",
        apellido: "",
        matricula: "",
        contrasena: "",
        confirmar: "",
        rol: "",
        contrasenaTemporal: null,
      },
      passwordHasBlurred: false,
      //selected: {id: "11", role:"Desconocido"},
      selected: null,
      submitted: false,
      password: '',
      confirmPassword: '',
      passwordRules: [
        (value) => !!value || 'Por favor ingresa una contraseña.',
        (value) => (value && value.length >= 6) || 'Minimo 6 caracteres',
      ],
      confirmPasswordRules: [
        (value) => !!value || 'Ingresa de nuevo la contraseña',
        (value) =>
            value === this.usuario.contrasena || 'Las contraseñas son diferentes.',
      ],
      userRules: [
        (value) => !!value || 'Nombre de usuario obligatorio',
        //(value) => ,
      ],
      error: false,
      mensajeError: '',
    };
  },
  computed: {
    passwordState() {
      return this.passwordHasBlurred
          // ? ( (this.usuario.contrasena.match("(?:[A-Za-z0-9.*+\\-?^${}()|[\\]\\\\]+ ){2}[A-Za-z0-9.*+\\-?^${}()|[\\]\\\\]+")
          ? ( (this.usuario.contrasena.match("(?:[A-Za-z0-9\\\\\\|\\.\\?\\*\\+\\(\\)\\{\\}\\$\\-\\[\\]\\^,_!@\"#%&/='¿¡ñ<>]+ ){2}[A-Za-z0-9\\\\\\|\\.\\?\\*\\+\\(\\)\\{\\}\\$\\-\\[\\]\\^,_!@\"#%&/='¿¡ñ<>]+")
              ? true
              : false) && this.usuario.contrasena.length >=12)
          : null;
    },
    confirmPasswordState() {
      return this.passwordHasBlurred
          ? this.usuario.contrasena == this.usuario.confirmar &&
          this.usuario.confirmar != ""
              ? true
              : false
          : null;
    },
  },
  methods: {
    mostrarUsuario(usuario) {

      this.usuario.matricula= usuario.matricula;
      this.usuario.username= usuario.username;
      this.usuario.contrasenaTemporal= usuario.contrasenaTemporal

      //confirmHabilitado: usuario.confirmHabilitado,

    },
    cambiarContrasena() {
      var datos={
        username: this.usuario.username,
        password: this.usuario.contrasena,
        contrasenaTemporal: this.usuario.contrasenaTemporal,
      };
      const key = sessionStorage.getItem('key');
      UsersDataService.cambiarContrasena(datos, key)
          .then(() => {
            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer)
                toast.addEventListener('mouseleave', this.$swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'success',
              title: 'Contraseña actualizada exitosamente.'
            });
          })
          .catch(e => {
            const Toast = this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', this.$swal.stopTimer)
                toast.addEventListener('mouseleave', this.$swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'error',
              title: 'Error al actualizar contraseña.'
            });
          });

      var datos1 = {
        username: this.usuario.username,
        password: this.usuario.contrasena,
      };

      UsersDataService.getUsuario(key).then(async(response) => {
        const decoded = await Crypto.desencriptar(response.data, key);
        const data = {
          usuario: decoded,
          accion: "Inicio de sesión" + sessionStorage.infoDevice,
          fechaCreacion: new Date(),
          tipo: "accion",
        };
        sessionStorage.setItem("usuarioLogueado", JSON.stringify(decoded)); //se almacena el usuario en la sesion activa
        AccionesDataService.create(data, key);
      });

      this.$router.push({
        path: "/monitoreo"
      });

    },

    CancelarCambioContrasena(){
      this.borrarDatosSessionStorage();
      this.$router.push("/login");
    },

    borrarDatosSessionStorage() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('username')
      sessionStorage.removeItem('idRol')
      sessionStorage.removeItem('usuarioFiltro')
      sessionStorage.removeItem('nombreUsuario')
      sessionStorage.removeItem('id_user')
      sessionStorage.removeItem('areaUser')
      sessionStorage.removeItem('user_')
      sessionStorage.removeItem('email')
      sessionStorage.removeItem('banMonitoreo')
      sessionStorage.removeItem('usuarioLogueado')
      sessionStorage.removeItem('banConfig')
      sessionStorage.removeItem('rol')
      sessionStorage.removeItem('ubicacionTiempoReal')
      sessionStorage.removeItem('key');
      localStorage.removeItem('aciqui_instance');
      localStorage.removeItem('tokenPush');
    },

  },
  mounted(){
    this.mostrarUsuario(this.$route.params);
    this.$nextTick(() => {

    });
  }

}
</script>

<style>
.submit-form {
  max-width: 400px;
}

.reset {
  min-height: 100vh;
}

@media screen and (max-height: 450px) {
  .reset {
    min-height: 85vh;
  }
}

.layered.box {
  box-shadow:
    0 1px 1px hsl(0deg 0% 0% / 0.075),
    0 2px 2px hsl(0deg 0% 0% / 0.075),
    0 4px 4px hsl(0deg 0% 0% / 0.075),
    0 8px 8px hsl(0deg 0% 0% / 0.075),
    0 16px 16px hsl(0deg 0% 0% / 0.075);
}

.box {
  border-radius: 2px;
  background-color: white;
}
</style>
